import { render, staticRenderFns } from "./WordsDictation1Form.vue?vue&type=template&id=40769d25&"
import script from "./WordsDictation1Form.vue?vue&type=script&lang=js&"
export * from "./WordsDictation1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports